import React from 'react'

import { Field } from 'formik'

import { Col, Form } from '_zari/core'

import { FechaInput } from 'sharedComponents/inputs/text'

import { KeyEventUtil } from 'utils'

const FechaDocumentoFormGroup = ({ iError, iTouched, fIsSubmitting, handleBlur, setFieldValue, vId, values }) => {
  React.useEffect(() => {
    if (!vId) {
      KeyEventUtil.leaveOnKeyEvent('inputDate-fechaDocumento')
    }
  }, [vId])

  const onBlur = React.useCallback(
    e => {
      handleBlur(e)

      setFieldValue('fechaVencimiento', e.target.value)
    },
    [handleBlur, setFieldValue]
  )

  const onKeyDown = React.useCallback(
    e => {
      let nextNode = 'codigoRucSelect'
      if (values._idSocio) {
        nextNode = 'inputselect-glosa'
        if (values.glosa) {
          nextNode = 'select-tipoDocumento'
          if (values.tipoDocumento) {
            nextNode = 'input-serieDocumento'
            if (values.serieDocumento) {
              nextNode = 'input-numeroDocumento'
            }
          }
        }
      }

      KeyEventUtil.leaveOnEnterOrTab(nextNode, e)
    },
    [values]
  )

  return (
    <Form.Group>
      <Form.Label text='FEC DOC' htmlFor='inputDate-fechaDocumento' md={4} alignRightAt='md' />
      <Col md={8}>
        <Field name='fechaDocumento'>
          {({ field }) => (
            <FechaInput
              {...field}
              id='inputDate-fechaDocumento'
              isInvalid={iTouched && iError}
              disabled={fIsSubmitting}
              onKeyDown={onKeyDown}
              onBlur={onBlur}
            />
          )}
        </Field>
        {iTouched && iError ? <Form.Feedback type='invalid'>{iError}</Form.Feedback> : null}
      </Col>
    </Form.Group>
  )
}

export default React.memo(FechaDocumentoFormGroup)
